import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-62719c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Bienvenido a nuestra sección de Webinar!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "¡Estamos encantados de presentarles esta nueva experiencia en el módulo de webinars!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Confiamos en que encontrarán este enfoque innovador enriquecedor y estimulante."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¡Esperamos que lo disfruten! ")
], -1))
const _hoisted_6 = { class: "cards" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["href"]

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import WebinarService from '@/services/WebinarService';
import WebinarI from '@/interfaces/WebinarInterface';
import { onMounted,ref,Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WebinarView',
  setup(__props) {

const service = new WebinarService()
const webinars:Ref<WebinarI> = ref({})
const loading:Ref<boolean> = ref(false)
const date = ref('')

onMounted(async()=>{
  loading.value = true;
  webinars.value = await service.GetLatestWebinar()
  if(webinars.value.datetime == null) { loading.value = false; return}
  const timestamp = new Date(webinars.value.datetime);
// Get local date and time components
const year = timestamp.getFullYear();
const month = timestamp.getMonth() + 1; // Months are 0-based, so January is 0
const day = timestamp.getDate();
const hours = timestamp.getHours();
const minutes = timestamp.getMinutes();
const seconds = timestamp.getSeconds();

// Format the local datetime string
date.value = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${addLeadingZero(day)} ${addLeadingZero(hours)}:${addLeadingZero(minutes)}`;

  loading.value = false
})

function addLeadingZero(number:number) {
    return number < 10 ? '0' + number : number;
}
  
return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: webinars.value.src,
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: webinars.value.image_url,
                alt: "webinar"
              }, null, 8, _hoisted_9),
              _createElementVNode("h4", null, "Fecha Inicio: " + _toDisplayString(date.value), 1),
              _createElementVNode("h4", null, _toDisplayString(webinars.value.title), 1),
              _createElementVNode("h5", null, [
                _createElementVNode("a", {
                  href: webinars.value.src,
                  target: "_blank"
                }, "Acceder", 8, _hoisted_10)
              ])
            ], 8, _hoisted_8)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})